import { Task } from "../models/task";

const TYPE_RETURN_DIFF = "difference";

export const normalizeTime = (value: number, quantity: number) => {
  if (value < 0) value = 0;

  return Array(quantity - String(value).length + 1).join("0") + value;
};

export const getHoursMinutesBySeconds = (seconds: number) => {
  const hours = Math.floor((seconds % 86400000) / 3600000);
  const minutes = Math.round(((seconds % 86400000) % 3600000) / 60000);

  return { hours, minutes };
};

export const getTransitTime = (task?: Task, typeReturn?: string) => {
  let diffTransitTime = 0;
  const {
    leavingWarehouse,
    arriveResidence,
    leavingNextJob,
    leavingResidence,
    arriveBackWarehouse,
  } = task!;

  if (leavingWarehouse && arriveResidence) {
    const leavingWarehouseDate = new Date(leavingWarehouse).setSeconds(0, 0);
    const arriveResidenceDate = new Date(arriveResidence).setSeconds(0, 0);

    diffTransitTime = arriveResidenceDate - leavingWarehouseDate;
  }

  if (leavingResidence && arriveBackWarehouse) {
    const leavingWarehouseDate = new Date(leavingResidence).setSeconds(0, 0);
    const arriveBackWarehouseDate = new Date(arriveBackWarehouse).setSeconds(0, 0);

    diffTransitTime += arriveBackWarehouseDate - leavingWarehouseDate;
  }

  if (leavingNextJob && arriveResidence) {
    const leavingNextJobDate = new Date(leavingNextJob).setSeconds(0, 0);
    const arriveResidenceDate = new Date(arriveResidence).setSeconds(0, 0);

    diffTransitTime += arriveResidenceDate - leavingNextJobDate;
  }

  if (typeReturn === TYPE_RETURN_DIFF) return diffTransitTime > 0 ? diffTransitTime : 0;

  const { hours, minutes } = getHoursMinutesBySeconds(diffTransitTime);

  return `${normalizeTime(hours, 2)}:${normalizeTime(minutes, 2)}`;
};

export const getBreakTime = (task?: Task, typeReturn?: string) => {
  let diffBreakTime = 0;

  const { breakBack, breakTake } = task!;

  if (breakTake && breakBack) {
    const breakTakeDate = new Date(breakTake).setSeconds(0, 0);
    const breakBackDate = new Date(breakBack).setSeconds(0, 0);

    diffBreakTime = breakBackDate - breakTakeDate;
  }

  if (typeReturn === TYPE_RETURN_DIFF) return diffBreakTime > 0 ? diffBreakTime : 0;

  const { hours, minutes } = getHoursMinutesBySeconds(diffBreakTime);

  return `${normalizeTime(hours, 2)}:${normalizeTime(minutes, 2)}`;
};

export const getWorkTime = (task?: Task, typeReturn?: string) => {
  let diffWorkTime = 0;

  const { arriveResidence, leavingResidence } = task!;

  if (arriveResidence && leavingResidence) {
    const arriveResidenceDate = new Date(arriveResidence).setSeconds(0, 0);
    const leavingResidenceDate = new Date(leavingResidence).setSeconds(0, 0);

    diffWorkTime = leavingResidenceDate - arriveResidenceDate;
  }

  if (typeReturn === TYPE_RETURN_DIFF) return diffWorkTime > 0 ? diffWorkTime : 0;

  const { hours, minutes } = getHoursMinutesBySeconds(diffWorkTime);

  return `${normalizeTime(hours, 2)}:${normalizeTime(minutes, 2)}`;
};

export const getTotalTime = (task?: Task) => {
  const transitTimeDiff = getTransitTime(task, TYPE_RETURN_DIFF) as number;
  const breakTimeDiff = getBreakTime(task, TYPE_RETURN_DIFF) as number;
  const workTimeDiff = getWorkTime(task, TYPE_RETURN_DIFF) as number;

  const totalDiff = transitTimeDiff + workTimeDiff - breakTimeDiff;

  const { hours, minutes } = getHoursMinutesBySeconds(totalDiff);

  return `${normalizeTime(hours, 2)}:${normalizeTime(minutes, 2)}`;
};
